
<div class="p-12 text-center">
  <p>{{'pages.reports.document.fileReportdescriptionDesc' | translate}}</p>
</div>


<!-- <div class="p-2">
  <h4>{{'pages.reports.document.currentPathDesc' | translate}}: <span class="click" (click)="fullResetPath()"><fa-icon [icon]="['fas', 'home']"></fa-icon>:/</span><span *ngFor="let item of currentPath; let i = index" (click)="resetPath(i)" class="click">{{item}}/</span></h4>
</div> -->


<div class="row pb-3">
  <div class="col-xl-1 hidden-lg"></div>
  <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="card" data-placement="top">
      <div class="card-body">

        <form>
          <div class="form-row justify-content-betwwen">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
              <label for="filename">{{ 'pages.reports.document.fileFilterDesc' | translate }}</label>
              <input type="text" class="form-control" name="filename" aria-describedby="filename" [(ngModel)]="fileFilter">
            </div>
            <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
              <label for="createdDate" class="ml-2">{{ 'pages.reports.document.createdFromTo' | translate }}</label>
              <div class="row">
                  <div class="col-6" style="padding-right: 0;">
                      <input type="date" class="form-control" name="updatedFrom" aria-describedby="updatedFrom" [(ngModel)]="createdFrom">
                  </div>
                  <div class="col-6" style="padding-left: 0;">
                      <input type="date" class="form-control" name="updatedTo" aria-describedby="updatedTo" [(ngModel)]="createdTo">
                  </div>
              </div>
          </div>
          </div>
          <button class="btn btn-primary" (click)="filter()">{{ 'pages.generic.filter' | translate }}</button>
          <button class="btn btn-primary" (click)="reset();">{{ 'pages.generic.reset' | translate }}</button>
        </form>

      </div>
    </div>
  </div>
  <div class="col-xl-1 hidden-lg"></div>
</div>

<div class="row mt-5">
  <div class="col-xl-1 hidden-lg"></div>
  <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">

    <div class="row mt-5 justify-content-center p-5" *ngIf="loading">
      <div class="spinner-border text-primary" role="status">
          <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
      </div>
    </div>

    <app-file-view
    *ngIf="!loading"
    [viewedFileStructure]="viewedFileStructure"
    [filesList]="filesList"
    class="mr-3"
    ></app-file-view>

  </div>
  <div class="col-xl-1 hidden-lg"></div>
</div>

<!-- <div class="row" *ngIf="!loading">
  <div class="col-12">
    <h4>>{{'pages.reports.document.foldersDesc' | translate}}</h4>
  </div>
  <div class="col-12">

    <span *ngFor="let item of viewedFileStructure  | keyvalue: originalOrder">
      <span *ngIf="(item.value | json) != '{}'" class="p-2" style="line-height: 1.5em; text-align: center; float:left;">
        <span class="click" (click)="openFolder(item.key)">
          <fa-icon [icon]="['far', 'folder']" size="5x" [styles]="{'stroke': 'orange', 'color': 'orange'}"></fa-icon>
          <br/>
          {{item.key}}
        </span>
      </span>
    </span>

    
  </div>
</div> -->

<br /><br />

<!-- <div class="row" *ngIf="!loading">
  <div class="col-12">
    <h4>>{{'pages.reports.document.filesDesc' | translate}}:</h4>
  </div>
  <div class="col-12">

    <span *ngFor="let item of viewedFileStructure  | keyvalue: originalOrder">
      <span *ngIf="(item.value | json) == '{}'" class="click p-1" (click)="downloadFile(currentPath, item.key)" style="display:block">
        <fa-icon [icon]="['far', 'file']" size="lg" [styles]="{'stroke': 'orange', 'color': 'orange'}"></fa-icon>
        {{item.key}}
      </span>
    </span>

  </div>
</div>

<br /><br /><br /> -->